/**
 * Admin Dashboard Content Component
 * - Displays key metrics and statistics
 * - Shows charts for bookings and user signups
 * - Lists recent pet finders and transactions
 * - Main dashboard after login
 */

import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import StatsGrid from "./Stats/StatsGrid";
import BookingsRevenueChart from "./Charts/BookingsRevenueChart";
import PetSignupsChart from "./Charts/PetSignupsChart";
import PetFinderTable from "./PetFinder/PetFinderTable";
import TransactionsList from "./Transactions/TransactionsList";
import RecentCustomers from "./Customers/RecentCustomers";
import { fetchDashboardData } from "../../redux/slices/dashboardSlice";

const AdminPanelContent = () => {
  const dispatch = useDispatch();
  const { data, status } = useSelector((state) => state.dashboard);

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchDashboardData());
    }
  }, [dispatch, status]);

  if (status === "loading") {
    return (
      <div className="p-4 sm:p-6 space-y-4 sm:space-y-6">
        <div className="flex items-center justify-center h-64">
          <div className="text-lg text-gray-600">Loading dashboard data...</div>
        </div>
      </div>
    );
  }

  if (status === "failed") {
    return (
      <div className="p-4 sm:p-6 space-y-4 sm:space-y-6">
        <div className="flex items-center justify-center h-64">
          <div className="text-lg text-red-600">Error loading dashboard data</div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 sm:p-6 space-y-4 sm:space-y-6">
      {/* Stats */}
      <StatsGrid dashboardData={data} />

      {/* Charts */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
        <BookingsRevenueChart />
        <PetSignupsChart />
      </div>

      {/* Pet Finder Table */}
      <PetFinderTable petFinderData={data.recent_pet_finder_data} />

      {/* Bottom Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
        <TransactionsList />
        <RecentCustomers recentUsers={data.recent_users} />
      </div>
    </div>
  );
};

export default AdminPanelContent;
